import { HiOutlineDocument, HiOutlineDocumentDuplicate } from "react-icons/hi";
import { PiPackageBold } from "react-icons/pi";

export const ProtocolsIcon = PiPackageBold;
export const WorkoutsIcon = HiOutlineDocumentDuplicate;
export const ExercisesIcon = HiOutlineDocument;
export const ExercisesIconEdit = HiOutlineDocument;
